import React from 'react';
import PropTypes from 'prop-types';
import GuestBrandedButton from './GuestBranded/components/GuestBrandedButton';
import { CookieBannerFooterStyles } from './CookieBanner.styles';

const CookieBannerFooter = ({
    bannerText,
    isConsentSettingsOpen,
    showDeclineNonEssentialButton,
    onDeclineNonEssential,
    onAcceptAll,
}) => {
    const styles = CookieBannerFooterStyles;

    return (
        <div style={styles.buttonRow}>
            {showDeclineNonEssentialButton && (
                <GuestBrandedButton
                    appearance="lined"
                    text={bannerText.declineNonEssentialButton}
                    onClick={onDeclineNonEssential}
                />
            )}
            <GuestBrandedButton
                appearance={isConsentSettingsOpen ? 'lined' : 'filled'}
                text={bannerText.acceptAllButton}
                onClick={onAcceptAll}
            />
        </div>
    );
};

CookieBannerFooter.propTypes = {
    bannerText: PropTypes.object.isRequired,
    isConsentSettingsOpen: PropTypes.bool,
    showDeclineNonEssentialButton: PropTypes.bool,
    onDeclineNonEssential: PropTypes.func,
    onAcceptAll: PropTypes.func,
};

CookieBannerFooter.defaultProps = {
    isConsentSettingsOpen: false,
    showDeclineNonEssentialButton: false,
    onDeclineNonEssential: () => {},
    onAcceptAll: () => {},
};

export default CookieBannerFooter;
